import React from 'react'
import { connect } from 'react-redux'
import FlightPaxReport from './FlightPaxReport'
import moment from 'moment'
import { createDateRange, getUserTimezone } from '../../utils/dateUtils'
import { DateTime } from 'luxon'

// Get today's date in the user's selected timezone
const getTodayInUserTimezone = () => {
  const userTimezone = getUserTimezone()
  const now = DateTime.now().setZone(userTimezone)
  return moment({ year: now.year, month: now.month - 1, day: now.day })
}

class FlightPaxReportContainer extends React.Component {
  state = {
    airlineId: null,
    stationId: null,
    service: null,
    startDate: getTodayInUserTimezone(),
    endDate: getTodayInUserTimezone(),
    flightNumber: '',
    searchArchived: false,
    isLoading: false,
  }

  createQuery = function () {
    const startRange = createDateRange(this.state.startDate)
    const endRange = createDateRange(this.state.endDate)

    return {
      airlineId: this.state.airlineId,
      stationId: this.state.stationId,
      flightNumber: this.state.flightNumber,
      startDate: startRange.start, // UTC ISO string
      endDate: endRange.end, // UTC ISO string
      serviceId: this.state.service ? this.state.service._id : undefined,
      createFromKiosk: true,
      source: this.state.searchArchived ? 'archived' : undefined,
    }
  }

  handleFilterChange = (key, value) => {
    this.setState({
      ...this.state,
      [key]: value,
    })
  }

  handleViewWebClick = () => {
    window.open(this.downloadHTMLLink(), '_blank')
  }

  downloadHTMLLink = () => {
    const url = new URL('/report/web', window.location.href)
    const query = this.createQuery()
    url.searchParams.set('name', 'flightPaxReport')
    for (const key of Object.keys(query)) {
      if (query[key]) url.searchParams.set(key, query[key])
    }
    return url.href
  }

  isDownloadable = () => {
    if (
      this.state.isLoading ||
      !this.state.startDate ||
      typeof this.state.startDate !== 'object' ||
      !this.state.endDate ||
      typeof this.state.endDate !== 'object'
    )
      return false

    // Airline and Service are both required for this report.
    return (
      this.state.startDate
        .startOf('day')
        .isBefore(this.state.endDate.endOf('day')) &&
      this.state.service !== null &&
      !!this.state.airlineId
    )
  }

  render() {
    return (
      <FlightPaxReport
        onFilterChange={this.handleFilterChange}
        onViewWebClick={this.handleViewWebClick}
        isDownloadable={this.isDownloadable()}
        filter={this.state}
        auth={this.props.auth}
      />
    )
  }
}

export default connect((state) => ({ auth: state.auth }))(
  FlightPaxReportContainer,
)
